/** One runnable mapping plugin, as `GET /plugins` lists it: a service with an
 *  ACTIVE plugin config. Exactly the pairs `POST /jobs` accepts. */
export interface MappingPlugin {
  service: string;
  plugin_id: string;
  version_id: string;
  model_name: string;
  activated_at: string | null;
}

export interface MappingServiceViewModel {
  id: string;
  /** The service key (`technical-manual`, `wd-mapping`, `ddt-mapping`). */
  kind: string;
  pluginId: string;
  modelName: string;
}

/** The mapping services the UI renders a dedicated layout for. A service the
 *  backend adds later still lists and runs; it renders the generic layout. */
export const ServiceKey = {
  TechnicalManual: "technical-manual",
  Wd: "wd-mapping",
  Ddt: "ddt-mapping",
} as const;
export type ServiceKey = (typeof ServiceKey)[keyof typeof ServiceKey];
